function ShowHide(props) {
    function handleShowHide() {
        if (props.logoHide === "block") {
            props.setLogoHide("none")
        }
        else {
            props.setLogoHide("block")
        }
    }

    return (
        <div style={{width: "100%", marginBottom: "10px"}}>
            <h3>Logo Visibility</h3>
            <h3 className="fileInputLabel" onClick={() => handleShowHide()}>Hide/Show {props.title}</h3>
        </div>
    )
}

export default ShowHide;